module.exports = __webpack_public_path__ + "static/media/pdfthumb.c6e892ed.png";